import { useAuth } from '../contexts/AuthContext';

export function ProfilePage() {
    const { user } = useAuth();

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-3xl font-semibold">Profile settings</h2>
                <p className="text-sm text-gray-500">Manage your account details.</p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-4">
                <div>
                    <p className="text-xs uppercase tracking-wide text-gray-500">Email</p>
                    <p className="text-lg font-medium text-gray-900">{user?.email || 'Not available'}</p>
                </div>

                <div>
                    <p className="text-xs uppercase tracking-wide text-gray-500">Account status</p>
                    <p className="text-sm text-gray-700">Active</p>
                </div>
            </div>
        </div>
    );
}
